import RatePicker from './RatePicker';

export default RatePicker;
export type { IRatePickerProps } from './RatePicker';
